<template>
    <div class="create-leave">
        <v-dialog :value="value.state"  max-width="600px" persistent scrollable>
             <v-card class="rounded-xl">
                <v-card-title class="text-h6 font-weight-bold pt-6 px-8 grey--text text--darken-3">
                    <v-icon left color="teal darken-4" class="mr-3">mdi-swap-horizontal</v-icon>
                    {{ value.item === undefined ? "Tạo Phiếu Điều Chuyển" : "Cập Nhật Phiếu Điều Chuyển"}}
                    <v-spacer></v-spacer>
                    <v-btn icon color="grey" @click="close"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                
                <v-card-text class="pa-8">
                <v-form @submit.prevent="saveData" v-model="valid" id="form" ref="form">
                    
                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-information-outline</v-icon>
                        THÔNG TIN CƠ BẢN
                    </div>
                    
                    <v-card outlined rounded="lg" class="grey lighten-5 mb-6">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngày bắt đầu:</label>
                                <v-menu
                                v-model="menuDate1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                    :value="formatValidFrom"
                                    clearable
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:clear="form.validFrom = null"
                                    :rules="[v=> !!v ||'Khoản mục bắt buộc!']" hide-details="auto" dense outlined
                                    class="rounded-lg bg-white"
                                    background-color="white"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    locale="vi"
                                    v-model="form.validFrom"
                                    @change="menuDate1 = false"
                                ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Lý do điều chuyển:</label>
                                <v-select :items="types" v-model="form.idType" :rules="[v=> !!v ||'Khoản mục bắt buộc!']" dense outlined hide-details="auto" class="rounded-lg bg-white" background-color="white"></v-select>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    
                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-account-switch</v-icon>
                        CHI TIẾT ĐIỀU CHUYỂN
                    </div>
                    
                    <v-card outlined rounded="lg" class="grey lighten-5 mb-6">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Điều chuyển từ:</label>
                                <v-autocomplete @change="fetchEmployee" v-model="form.fromDepartmentCode" :items="departments" :rules="[v=> !!v ||'Khoản mục bắt buộc!']" prepend-inner-icon="mdi-store" dense outlined hide-details="auto" class="rounded-lg bg-white" background-color="white"></v-autocomplete>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Nhân sự:</label>
                                <v-autocomplete :disabled="!!!form.validFrom" v-model="form.employeeCode" :items="employees" :rules="[v=> !!v ||'Khoản mục bắt buộc!']" prepend-inner-icon="mdi-account" dense outlined hide-details="auto" class="rounded-lg bg-white" background-color="white" :placeholder="!!!form.validFrom ? 'Chọn ngày BĐ trước' : ''"></v-autocomplete>
                            </v-col>
                            
                            <v-col cols="12">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Điều chuyển đến:</label>
                                <v-autocomplete v-model="form.toDepartmentCode" :items="departments" :rules="[v=> !!v ||'Khoản mục bắt buộc!']" prepend-inner-icon="mdi-home-city" dense outlined hide-details="auto" class="rounded-lg bg-white" background-color="white"></v-autocomplete>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    
                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-note-edit</v-icon>
                        GHI CHÚ <span class="red--text ml-1">*</span>
                    </div>

                    <v-card outlined rounded="lg" class="grey lighten-5">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea placeholder="Bắt buộc nhập lý do hoặc thông tin bổ sung" v-model="form.note" :rules="[v=> !!v || 'Vui lòng nhập ghi chú bắt buộc!']" hide-details="auto" outlined dense class="rounded-lg bg-white" background-color="white" rows="3"></v-textarea>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                </v-form>       
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-6">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="font-weight-bold px-8" @click="close">
                        HỦY BỎ
                    </v-btn>
                    <v-btn dark form="form" color="teal darken-4" type="submit" class="rounded-pill elevation-2 px-10 font-weight-bold ml-4">
                        GỬI YÊU CẦU
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
             </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DatePicker from "../../../components/DatePicker";
import http from '../../../components/services/http-common';
import EventBus  from "../../../components/services/EventBus";
import moment from 'moment'

export default {
    name: "Create",
    components: {
        "date-picker": DatePicker,
    },
    computed:{
        
        formatValidFrom () {
            return this.form.validFrom ? moment(this.form.validFrom).format('DD/MM/YYYY') : ''
        },
        amount() {
            let amount = 0;
            const day = (1000*60*60*24);
            if(Array.isArray(this.dates))
            {
                if(this.form.isMultiple)
                {
                    if(this.dates.length == 2){
                        let first = new Date(this.dates[0]);
                        let last = new Date(this.dates[1]);
                        amount = (last -first)/day;
                        return Math.abs(amount) +1;
                    }
                }
            }
            return amount;
        }
    },
    watch: {
        value: {
            handler(val){
                if(val.item != undefined)
                    this.fetchData();
                if(val.state)
                    return val || this.close();
            }
        },
        
        "form.validFrom": {
            handler(val)
            {
                this.fetchEmployee()
            }
        },
        "form.isMultiple": {
            handler(val)
            {
                if(val)
                    this.dates = [];
                else
                    this.dates = "";
            }
        },
    },

    props: ["value"],
    data () {
        return {
            //URL
            ROOT_URL: "employeeRotationRequests",
            LEAVEPLAN_URL: "leavePlans/valid-leave-plan/",
            LEAVEPLAN_URL2: "leavePlans/valid-leave-plan2/",

            //DATA
            valid: false,
            dateMenu: false,
            employees:[],
            departments:[],
            dates: "",
            ShiftObject: "",
            formData: {
                leaveAmountTypes: [
                    {text: "Nghỉ cả ngày", value: "1"},
                    {text: "Nghỉ 1/2 ngày", value: "0.5", disabled: false},
                ],
                fromMenu: false,
                toMenu: false,
                leavePlans: [],
            },
            
            menuDate1: false,
            types: [],
            form: {
                employeeCode: "",
                fromDepartmentCode:"",
                toDepartmentCode: "",
                validFrom: "",
                validTo: "2100-01-01",
                idType: null,
                note: ""
            },
            defaultForm: {
                employeeCode: "",
                fromDepartmentCode:"",
                toDepartmentCode: "",
                validFrom: "",
                validTo: "2100-01-01",
                idType: null,
                note: ""
            },

            //EMPLOYEE DIALOG
            employeeDialog: false,
            selectedField: "",
        }
    },
    methods: {
        messageToast (eventObj) {
            EventBus.$emit('hasMessage', eventObj);
        },
        errorToast (eventObj)
        {
            EventBus.$emit('hasError', eventObj);
        },

        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },
        dateApply (){
            if(this.isMultiple)
            {
                let dates = this.dates;
                let dt0 = new Date(dates[0]);
                let dt1 = new Date(dates[1]);
                if(dt0> dt1)
                    this.dates = [dates[1], dates[0]];
            }
            this.$refs.menu.save(this.dates);
        },

        close () {
            this.$emit("CloseDialog");
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
        },
        
        fetchData () {
            return http.get(this.ROOT_URL + "/" + this.value.item.code)
            .then(res => {
                //fetch result
                let item = res.data.item;
                this.form = Object.assign({}, item);
                console.log(this.form);
            })
            .catch(err => {
                console.log(err);
            });
        },

        fetchEmployee() {
            const obj = JSON.parse(localStorage.getItem('user'))
            var currentEmp = obj.employeeCode
            if(this.form.validFrom){
                return http.get("employees/fetch", {
                    params:{
                        asm: false,
                        detail: true,
                        asmArea: "",
                        date: this.form.validFrom,
                        all: 0
                    }
                }).then(res => {
                    var filtered = res.data.filter(x=>x.asm != null && x.departmentCode== this.form.fromDepartmentCode)
                    this.employees = filtered.map(x => {
                        return {
                            text: `${x.name}`,
                            value: x.code
                        }
                    })
                })
            }
        },
        fetchDepartment() {
            return http.get("departments").then(r => {
                this.departments = r.data.map(x => {
                    return {
                        text: x.name,
                        value: x.code
                    }
                })
            })
        },

        fetchType() {
            return http.get("EmployeeRotationRequests/fetch-type").then(res => res.data.data).then(data => {
                this.types = data.map(x => {
                    return {
                        text: `${x.name}`,
                        value: x.id
                    }
                })
            })
        },
        
        saveData() {
            this.$refs.form.validate();
            if(this.valid)
            {
                if(!this.value.item)
                {
                    return http.post(this.ROOT_URL, this.form)
                    .then(res => {
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                        // this.errorToast({message: err.response.data.message, toast: true})
                    }).finally(() => {
                        this.close()
                    })
                } else {
                    return http.put(this.ROOT_URL + "/" + this.value.item.code, this.form)
                    .then(res => {
                        let eventObj = {
                            color: "success",
                            message: "Cập nhật thành công",
                            toast: true,
                        };
                        this.messageToast(eventObj);
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                        throw "Đã có lỗi xảy ra"
                    }).finally(() => {
                        this.close()
                    })
                }
            }
        },
    },
    mounted() {
        this.fetchType()
        this.fetchDepartment()
    }
}
</script>
